import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PraticaProgressService } from '../_core/services/pratica-progress.service';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../_shared/shared.module';
import { LabelPipeModule } from '../_shared/label-pipe/label-pipe.module';
import { PraticaSection } from '../pratica/models/pratica-section';

@Component({
  selector: 'app-pratica-detail',
  standalone: true,
  imports: [RouterModule, SharedModule, LabelPipeModule],
  templateUrl: './pratica-detail.component.html',
  styleUrls: ['./pratica-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PraticaDetailComponent implements OnInit {
  links: PraticaSection[] = [
    PraticaSection.APPLICANT,
    PraticaSection.ANAGRAPHICS,
    PraticaSection.REQUESTS,
    PraticaSection.SCORE,
    PraticaSection.PRESENTATION_SHEET,
    PraticaSection.DOCUMENTS,
  ];

  constructor(protected praticaProgressService: PraticaProgressService) {}

  ngOnInit(): void {
    if (this.praticaProgressService.scoreDisabled) {
      this.links.splice(this.links.indexOf(PraticaSection.SCORE), 1);
    }
    if (this.praticaProgressService.presentationSheetDisabled) {
      this.links.splice(
        this.links.indexOf(PraticaSection.PRESENTATION_SHEET),
        1
      );
    }
  }
}
